import React from 'react';
import KioskHeader from '../components/Esper/AndroidX86/KioskHeader';
import Layout from '../layout';
import Android from '../assets/v2/androidx86/group-8.svg';
import KioskSecondPage from '../components/Esper/AndroidX86/KioskSecondPage';
import KioskSectionFive from '../components/Esper/AndroidX86/KioskSectionFive';
import TestSectionFour from '../components/Esper/AndroidX86/TestSectionFour';
import messages from '../i18n/en';

export default (props: any) => (
  <Layout
    messages={messages}
    ogImage={Android}
    title={'Run Android on x86 Devices | Esper Enhanced Android Devices'}
    description={`Give your purpose-built x86 devices new life by using Esper for x86 Android. Use Android OS on x86 devices from Esper's cloud platform for Android DevOps.`}
    keywords={`x86 Device, x86 Android`}
    className="first-page"
    location={props.location}
  >
    <KioskHeader />
    <TestSectionFour />
    <KioskSecondPage />
    <KioskSectionFive />
  </Layout>
);
